import { useEffect } from "react";
import PropTypes from "prop-types";
import { connect } from "react-redux";
import { setFeatureFlags } from "../../store/actions/featureFlags.actions";
import { getAmplitudeFeatureFlags } from "../../util/getAmplitudeFeatureFlags";

const FeatureFlagsInitializer = ({ setFeatureFlags }) => {
  const flags = getAmplitudeFeatureFlags();
  useEffect(() => {
    setFeatureFlags(flags);
  }, [setFeatureFlags]);

  return null;
};

// Inject the dispatch function as a prop
const mapDispatchToProps = (dispatch) => ({
  setFeatureFlags: (flags) => dispatch(setFeatureFlags(flags)),
});

// Prop validation
FeatureFlagsInitializer.propTypes = {
  setFeatureFlags: PropTypes.func.isRequired,
};

// Connect the component to Redux
export default connect(null, mapDispatchToProps)(FeatureFlagsInitializer);
